import { DialogContent, DialogTitle, Drawer } from "@mui/material";

import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SelectInput } from "components/forms";
import { HandlerType, HandlerTypes } from "interfaces/handlerType";
import { INotificationHandler } from "interfaces/notification.interface";

import { TempEmail } from "../forms/TempEmail";
import { TempNetNordic } from "../forms/TempNetNordic";
import { TempSensio } from "../forms/TempSensio";
import { TempSkyresponse } from "../forms/TempSkyresponse";
import { TempSMS } from "../forms/TempSMS";
import { TempWebhook } from "../forms/TempWebhook";

type NotificationHandlerDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  defaultValues?: INotificationHandler;
  zoneId: string;
};

export function NotificationHandlerDialog({
  isOpen,
  onClose,
  defaultValues,
  zoneId,
}: NotificationHandlerDialogProps) {
  const { t } = useTranslation();

  const { control, watch } = useForm<{ handlerType: HandlerType }>({
    defaultValues: {
      handlerType: defaultValues?.type ?? "sms",
    },
    mode: "onChange",
  });

  const type = watch("handlerType");

  const disabled = !!defaultValues;

  const props = { disabled, zoneId, onClose };

  return (
    <Drawer open={isOpen} onClose={onClose} anchor={"right"}>
      <DialogTitle>
        {defaultValues
          ? t("notification_handler_details")
          : t("add_a_notification_handler")}
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          width: "500px",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <SelectInput
          control={control}
          fieldName={"handlerType"}
          label={t("type")}
          options={Object.values(HandlerTypes).map((type) => ({
            id: type,
            label: t(type),
          }))}
          disabled={disabled}
          placeholder={t("select_notification_handler_type")}
          sx={{ paddingBottom: 0 }}
        />
        {type === "sms" && (
          <TempSMS
            {...props}
            defaultValues={
              defaultValues?.type === HandlerTypes.sms ? defaultValues : null
            }
          />
        )}
        {type === "email" && (
          <TempEmail
            {...props}
            defaultValues={
              defaultValues?.type === HandlerTypes.email ? defaultValues : null
            }
          />
        )}
        {type === "webhook" && (
          <TempWebhook
            {...props}
            defaultValues={
              defaultValues?.type === HandlerTypes.webhook
                ? defaultValues
                : null
            }
          />
        )}
        {type === "sensio" && (
          <TempSensio
            {...props}
            defaultValues={
              defaultValues?.type === HandlerTypes.sensio ? defaultValues : null
            }
          />
        )}
        {type === "skyresponse" && (
          <TempSkyresponse
            {...props}
            defaultValues={
              defaultValues?.type === HandlerTypes.skyresponse
                ? defaultValues
                : null
            }
          />
        )}
        {type === "netnordic" && (
          <TempNetNordic
            {...props}
            defaultValues={
              defaultValues?.type === HandlerTypes.netnordic
                ? defaultValues
                : null
            }
          />
        )}
      </DialogContent>
    </Drawer>
  );
}
